/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://q225zfr3kg.execute-api.us-west-2.amazonaws.com/staging",
            "region": "us-west-2"
        },
        {
            "name": "account",
            "endpoint": "https://g6ef2meyuh.execute-api.us-west-2.amazonaws.com/staging",
            "region": "us-west-2"
        },
        {
            "name": "webhook",
            "endpoint": "https://h65pfd4qjb.execute-api.us-west-2.amazonaws.com/staging",
            "region": "us-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://b2uu4cgvpzdflcpd2rl4ujwiey.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-west-2:8944f8b4-3ac2-4107-9c2b-5d9fd878a72b",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_ReinaQkSn",
    "aws_user_pools_web_client_id": "5o8ud6vaqcualcr3hbeeilloh6",
    "oauth": {
        "domain": "sweamers2e43a8c0-2e43a8c0-staging.auth.us-west-2.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://staging.sweamers.com/,https://www.sweamers.com/",
        "redirectSignOut": "http://localhost:3000/,https://staging.sweamers.com/,https://www.sweamers.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
